"use client";

import React from "react";
import { Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "Structured Cabling",
        path: "/ServicesPage"
      }, {
        label: "Voice & Data",
        path: "/ServicesPage"
      }, {
        label: "Security Systems",
        path: "/ServicesPage"
      }, {
        label: "IT Field Support",
        path: "/FieldSupportPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.path} className="text-sm text-muted-foreground transition-colors hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterHub() {
  const resourceLinks = [{
    label: "MSPs & GCs",
    path: "/AboutPage"
  }, {
    label: "Site Surveys",
    path: "/FieldSupportPage"
  }, {
    label: "Request Estimate",
    path: "/ContactPage"
  }];
  const socialLinks = [{
    icon: Linkedin,
    path: "https://linkedin.com/company/voltex-it/",
    label: "LinkedIn"
  }];
  return <section data-section-id="229814" id="footer" className="bg-background text-foreground py-16 lg:py-20 border-t border-primary/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          
          <div className="lg:col-span-4 flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block group">
              <div className="bg-primary px-3 py-2 rounded-md transition-transform group-hover:scale-105">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645714/img/FullLogo_Transparent_NoBuffer (1).png" alt="Low Voltage Techs Logo" className="h-7 w-auto" loading="lazy" />
              </div>
            </Link>
            <p className="text-sm text-muted-foreground font-default leading-relaxed max-w-sm">Voltex IT delivers professional low-voltage and IT field services across the Kansas City Metro. We specialize in POT Replacement, LTE/5g primary and backup internet, structured cabling, business phone systems, UCaaS, and Security System support. Serving commerical clients with reliable , hands-on installation and tech support.</p>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-default mb-6 text-base font-bold uppercase tracking-widest text-foreground">
              Services
            </h3>
            <MenuProvider menu_id="33">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-default mb-6 text-base font-bold uppercase tracking-widest text-foreground">
              Partners
            </h3>
            <ul className="space-y-3">
              {resourceLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="text-sm text-muted-foreground transition-colors hover:text-primary">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-default mb-6 text-base font-bold uppercase tracking-widest text-foreground">
              KC Office
            </h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-mono">
              <li className="flex items-start gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map-pin mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:cihh8o" data-ast-start="4291" data-ast-end="4349"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:h3rabf" data-ast-start="4366" data-ast-end="4396">&nbsp;Headquarterd in Kansas City&nbsp;</span></li>
              
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>field-ops@voltex-it.com</span>
              </li>
            </ul>

            <div className="mt-8 flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <div key={i} data-index={i}>
                    <Link to={social.path} aria-label={social.label} className="flex size-9 items-center justify-center bg-muted/20 text-muted-foreground transition-all hover:bg-primary hover:text-primary-foreground shadow-sm">
                      <Icon className="size-4" />
                    </Link>
                  </div>;
            })}
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-primary/30 pt-8 md:flex-row">
          <p className="text-xs font-mono text-muted-foreground uppercase tracking-tighter">
            &copy; 2026 Voltex IT. All Rights Reserved. A division of Techesia Solutions LLC.
          </p>
          <div className="flex items-center gap-3 text-xs font-mono text-muted-foreground uppercase">
            <Link to="#" className="transition-colors hover:text-primary">
              Privacy
            </Link>
            <span className="size-1 rounded-lg bg-primary" aria-hidden="true" />
            <Link to="#" className="transition-colors hover:text-primary">
              Terms
            </Link>
            <span className="size-1 rounded-lg bg-primary" aria-hidden="true" />
            <Link to="#" className="transition-colors hover:text-primary">
              Compliance
            </Link>
          </div>
        </div>
      </div>
    </section>;
}